import { Default_getInstancejyc493d440j2 as Default_getInstance } from '../../../../../kotlinx-serialization-kotlinx-serialization-json/kotlinx/serialization/json/Json.mjs';
import {
  Companion_getInstancevwry16b2g9ke as Companion_getInstance,
  Messageyu2c6n5qdmq as Message,
} from './Message.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { mapCapacity1h45rc3eh9p2l as mapCapacity } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { System_instance3k0g5wk7vsmvs as System_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Clock.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { plus20p0vtfmu0596 as plus } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function formatMessage($this, $receiver) {
  var tmp = Default_getInstance();
  var tmp_0 = Companion_getInstance().x28();
  var tmp0_safe_receiver = $receiver.p2f_1;
  var tmp_1;
  if (tmp0_safe_receiver == null) {
    tmp_1 = null;
  } else {
    // Inline function 'kotlin.collections.mapValues' call
    // Inline function 'kotlin.collections.mapValuesTo' call
    var destination = LinkedHashMap().cc(mapCapacity(tmp0_safe_receiver.q2()));
    // Inline function 'kotlin.collections.associateByTo' call
    var _iterator__ex2g4s = tmp0_safe_receiver.l3().p1();
    while (_iterator__ex2g4s.q1()) {
      var element = _iterator__ex2g4s.r1();
      var tmp_2 = element.m3();
      // Inline function 'kotlin.collections.component2' call
      var value = element.n3();
      var tmp$ret$4 = toString(value);
      destination.x4(tmp_2, tmp$ret$4);
    }
    tmp_1 = destination;
  }
  var tmp_3 = tmp_1;
  var tmp_4 = System_instance.yq().toString();
  var tmp1_safe_receiver = $receiver.l2f_1;
  return tmp.o1n(tmp_0, new (Message())($receiver.k2f_1.v1_1, $receiver.m2f_1, $receiver.n2f_1, tmp_3, tmp_4, tmp1_safe_receiver == null ? null : tmp1_safe_receiver.r2f(), throwableToString($this, $receiver.o2f_1)));
}
function throwableToString($this, $receiver) {
  if ($receiver == null) {
    return emptyList();
  }
  var msg = emptyList();
  var current = $receiver;
  while (!(current == null) && !equals(current.cause, current)) {
    msg = plus(msg, ", Caused by: '" + current.message + "'");
    current = current.cause;
  }
  return msg;
}
var JsonFormatterClass;
function JsonFormatter() {
  if (JsonFormatterClass === VOID) {
    class $ {
      h2f(loggingEvent) {
        return formatMessage(this, loggingEvent);
      }
      toString() {
        return 'JsonFormatter';
      }
      hashCode() {
        return -1288108928;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof JsonFormatter()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'JsonFormatter');
    JsonFormatterClass = $;
  }
  return JsonFormatterClass;
}
var JsonFormatter_instance;
function JsonFormatter_getInstance() {
  return JsonFormatter_instance;
}
//region block: init
JsonFormatter_instance = new (JsonFormatter())();
//endregion
//region block: exports
export {
  JsonFormatter_instance as JsonFormatter_instance3dl7s47t3s4rb,
};
//endregion

//# sourceMappingURL=JsonFormatter.mjs.map
